import * as React from "react";
const SvgFiRrFaceSwear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-swear_svg__a)">
      <path
        fill="#062147"
        d="M12 2C6.486 2 2 6.486 2 12a1 1 0 1 1-2 0C0 5.383 5.383 0 12 0s12 5.383 12 12a1 1 0 1 1-2 0c0-5.514-4.486-10-10-10m6.8 4.398a1 1 0 0 0-1.4-.197s-2.795 2.103-2.839 2.138l-.008.006-.002.002a1.49 1.49 0 0 0-.55 1.153 1.5 1.5 0 0 0 3 0c0-.154-.03-.3-.074-.439l1.675-1.262a1 1 0 0 0 .197-1.4zM9.45 8.347l-.003-.002-.008-.006c-.044-.036-2.838-2.138-2.838-2.138a.999.999 0 1 0-1.203 1.597L7.073 9.06C7.03 9.2 7 9.345 7 9.499a1.5 1.5 0 0 0 3 0 1.49 1.49 0 0 0-.55-1.153zm-3.643 9.44-3.285-.548a.625.625 0 0 1 .103-1.24H5.27c.356 0 .688.192.867.5a.998.998 0 1 0 1.73-1.001 3.01 3.01 0 0 0-2.598-1.499H5a1 1 0 1 0-2 0h-.376A2.627 2.627 0 0 0 0 16.623C0 17.911.923 19 2.193 19.211l3.285.548a.625.625 0 0 1-.103 1.24H2.732c-.356 0-.688-.192-.867-.5A.997.997 0 0 0 .5 20.134 1 1 0 0 0 .135 21.5a3.01 3.01 0 0 0 2.598 1.499h.268a1 1 0 1 0 2 0h.376a2.627 2.627 0 0 0 2.624-2.624 2.62 2.62 0 0 0-2.194-2.588M11 13.999a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1m11 4v2h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-2v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-2h-1a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v1h2v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2zm-2 0h-2v2h2zm-9 4a1 1 0 1 0 .001 2 1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-swear_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSwear;
